module.exports = __webpack_public_path__ + "img/anex_square.1deea39a.svg";